import { SalesContractDashboard } from "@/components/sales-contracts/sales-contract-dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/sales-dashboard")({
	component: SalesDashboardPage,
});

function SalesDashboardPage() {
	return (
		<div className="container mx-auto px-4 py-6">
			<div className="mb-6">
				<h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
				<p className="text-gray-600 mt-2">Monitor your recurring sales performance and contract status</p>
			</div>
			<SalesContractDashboard />
		</div>
	);
}
